import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateBurialDetailsCmConstants {
    static STEP_TITLE = "Burial details";
    static DETAILS_FORM_GROUP_NAME = "burialForm";
    static CEMETERY_CONTROL = "cemeteryId";
    static CEMETERY_LABEL = "Which cemetery / graveyard are you applying to?";
    static BURIAL_TYPE_CONTROL = "type";
    static BURIAL_TYPE_LABEL = "Burial type";
    static BURIAL_DATE_CONTROL = "burialDate";
    static BURIAL_DATE_LABEL = "Burial date";
    static BURIAL_TYPE_PH = "Select burial type";
    static DESCRIPTION_CONTROL = "description";
    static DESCRIPTION_LABEL = "Description";
    static DEFAULT_CEMETERY_NAME = "Any";
    static VALIDATION_MESSAGES = {
        burialType: {
            required: `Burial type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        },
        burialDate: {
            required: `Burial date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
            minimumDate: `Date must be greater than: `
        },
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
